import { logProvider } from "../../services/logService";

/**
 * 🔁 Periodically sync all providers in Redux to the /pro endpoint via logService
 * @param {object} store - Redux store instance
 */
export const syncProvidersToServer = (store) => {
  return async (dispatch, getState) => {
    const providerMap = getState().providers || {};
    const providers = Object.values(providerMap);

    console.log("🔍 Extracted providers:", providers);

    if (!Array.isArray(providers) || providers.length === 0) {
      console.log("📭 No providers to sync");
      return;
    }

    try {
      await logProvider(providers, store); // ✅ pass store explicitly
      console.log("✅ Synced providers via logService");
    } catch (err) {
      console.error("💥 Failed to sync providers via logService:", err);
    }
  };
};